<template>
  <div class="l-container container">
    <div>
      <div class="step">
        <Step :currentStep="1" :steps="steps" />
      </div>
      <div class="title">
        <h1>ベネポ利用申請</h1>
      </div>
    </div>

    <a-divider />
    <div class="box">
      <div class="box-content">
        <div>
          <Item :data="dataItemOrder" />
        </div>
        <div>
          <SectionContentTitle
            :lineType="lineType.vertical"
            :titleContent="titleContent[0]"
          />
          <div class="menu-content1">
            <div class="items-content">
              <div class="item-content gap-3">
                <p>宿泊期間</p>
                <span class="mr-2">{{customerPlan ? customerPlan.stayDayJP : ''}}</span>
                <span class="mr-2">{{customerPlan ? customerPlan.stayNights : ''}} 泊</span>
                <span class="mr-2">{{customerPlan ? customerPlan.stayRooms : ''}} 部屋</span>
                <span class="mr-2">（大人{{totalAdultPeople | formatInteger}}名/子ども{{totalChildren | formatInteger}}名）</span>
              </div>
              <div class="item-content gap-3">
                <p>チェックイン</p>
                <span class="mr-2">{{value_time_picker}}:00</span>
              </div>
            </div>
            <div class="totalPrice">
              <p>合計</p>
              <strong>{{ totalAmount | formatCurrency }}</strong>
            </div>
          </div>
        </div>
        <a-divider />

        <div class="menu-content2">
          <SectionContentTitle
            :lineType="lineType.vertical"
            :titleContent="titleContent[1]"
          />
          <div class="content">
            <div class="quantity">
              <p>数量</p>
              <div class="ml-4 category">
                必須
              </div>
            </div>
            <div class="benepoOwned">
              <div class="benepo-item">
                <p>保有ベネポ</p>
                <span>{{ total_point_benepo }}</span>
              </div>
              <a-radio-group v-model="checkedValue" @change="onChange">
                <a-radio :value="0" :disabled="notUseAll">
                  すべてのポイントを利用する
                </a-radio>
                <a-radio :value="1" :disabled="notUseAPart">
                  一部のポイントを利用する
                </a-radio>
                <a-radio :value="2" :disabled="notUse">
                  利用しない
                </a-radio>
              </a-radio-group>
              <div v-if="checkedValue !== 2">
                <div class="input">
                  <div class="input-item items-center">
                    <a-input
                      @blur="checkValue"
                      :disabled="checkedValue === 0" 
                      type="number" class="text-input" 
                      v-model="point_benepo"
                    />
                    <span class="self-center ml-2" >ベネポ</span>
                  </div>
                  <span class="font-bold mt-2">{{ numBenepo() | formatCurrency }}分</span>
                </div>
                <span class="alert-message" v-if="checkErrorAlert()">{{checkErrorAlert()}}</span>
              </div>
            </div>
          </div>
        </div>
        <a-divider />
        <div class="fees">
          <div class="fee-item">
            <div class="item-title">
              <p>宿泊料合計①</p>
            </div>
            <div class="item-price">
              <span>{{totalAmount | formatCurrency}}</span>
            </div>
          </div>
          <div class="fee-item">
            <div class="item-title">
              <p>補助クーポン利用申請額②</p>
            </div>
            <div class="item-price">
              <span>{{couponAmount | formatCurrency}}</span>
            </div>
          </div>
          <div class="fee-item">
            <div class="item-title">
              <p>ベネポ利用申請額③</p>
            </div>
            <div class="item-price">
              <span>{{numBenepo() | formatCurrency}}</span>
            </div>
          </div>
          <div class="fee-item">
            <div class="item-title">
              <p>負担予定額(① - ② - ③)</p>
            </div>
            <div class="item-price">
              <span>{{totalCost | formatCurrency}}</span>
            </div>
          </div>
        </div>
        <a-divider />
        <div class="buttons">
          <button @click="handleBack()" class="c-btn btn-white">
            <span class="">戻る</span>
          </button>
          <button @click="saveData()" class="c-btn btn-grey">
            <span class="">次へ</span>
          </button>
        </div>
      </div>
    </div>
    <div class="items">
      <div class="item">
        <a @click="gotoScreen(1)">トップ</a>
        <i class="icon icon-bor-arrow-right " />
      </div>
      <div class="item">
        <a @click="gotoScreen(2)">プラン詳細</a>
        <i class="icon icon-bor-arrow-right " />
      </div>
      <div class="item">
        <a @click="gotoScreen(3)">申込</a>
        <i class="icon icon-bor-arrow-right " />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { Step, Item, SectionContentTitle } from '@/components/compound'
import { SAVE_DATA_BS_APP_02_008, GET_BENEPO_POINT } from '@/store/modules/bs_app/actions' 

export default {
  components: {
    Step,
    Item,
    SectionContentTitle
  },
  data() {
    return {
      customerPlan: null,
      value_time_picker: '',
      checkedValue: 0,
      titleContent: ['お申し込み内容', 'ベネポ利用'],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      steps: [
        {
          id: 1,
          label: '申請内容を入力'
        },
        {
          id: 2,
          label: '申込確認'
        },
        {
          id: 3,
          label: '申込完了'
        }
      ],
      total_point_benepo: 0,
      point_benepo: 0,
      dataItemOrder: {},
      totalAmount: 0,
      couponAmount: 0,
      amount3: 0,
      priceOfAPoint: 1,
      notUse: false,
      notUseAll: false,
      notUseAPart: false,
      totalAdultPeople: 0,
      totalChildren: 0
    }
  },
  mounted() {
    this.getTotalPoint()
    if (this.bsApp02008) {
      this.checkedValue = this.bsApp02008.checkedValue
      this.point_benepo = this.bsApp02008.point_benepo
      this.itemContent = this.bsApp02008.itemContent
    }
    this.customerPlan = this.customerPlanState
    this.getPlanBasicInfo()
  },
  watch: {
    checkedValue() {
      if(this.checkedValue === 0) {
        this.point_benepo = this.total_point_benepo
      }
    }
  },
  computed: {
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    },
    customerPlanState() {
      return _.cloneDeep(this.$store.getters.customerPlan)
    },
    totalCost() {
      return this.totalAmount - this.couponAmount - this.amount3 > 0 ? this.totalAmount - this.couponAmount - this.amount3 : 0
    },
    bsApp02004() {
      return _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app.bs_app_02_004', null))
    },
    bsApp02008() {
      return _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app.bs_app_02_008', null))
    },
    totalSubsidyDiscount() {
      return _.get(this.customerPlanState, 'couponPlanData.totalDiscountAmount', 0)
    }
  },
  methods: {
    onChange() {
    },
    checkValue() {
      if(this.point_benepo > (this.totalAmount - this.couponAmount)  / this.priceOfAPoint) {
        this.point_benepo = (this.totalAmount - this.couponAmount)  / this.priceOfAPoint
      }
    },
    mountData() {
      const bs_app_02_001 = _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app.bs_app_02_001', null))
      if(bs_app_02_001) {
        this.value_time_picker = bs_app_02_001.checkinTime // sửa lại biến
        this.totalAmount = bs_app_02_001.totalFee
        this.totalAdultPeople = bs_app_02_001.totalAdultPeople
        this.totalChildren = bs_app_02_001.totalChildren
      }
      if(this.totalAmount < this.numBenepo()) {
        this.checkedValue = 1
        this.notUse = false
        this.notUseAll = true
        this.point_benepo = (this.totalAmount / this.priceOfAPoint)
      }
      if(this.total_point_benepo === 0) {
        this.checkedValue = 2
        this.notUseAll = true
        this.notUseAPart = true
      }
      this.customerPlan = this.customerPlanState
      if(this.totalSubsidyDiscount) {
        this.couponAmount = this.totalSubsidyDiscount
        if(this.couponAmount >= this.totalAmount) {
          this.checkedValue = 2
          this.notUseAll = true
          this.notUseAPart = true
        } else if(this.totalAmount < this.couponAmount + this.numBenepo()) {
          this.checkedValue = 1
          this.notUseAll = true
          this.notUse = false
          this.point_benepo = (this.totalAmount - this.couponAmount)  / this.priceOfAPoint
        } else{
          this.checkedValue = 0
          this.notUseAPart = false
          this.notUse = false
        }
      }
    },
    getPlanBasicInfo() {
      const planBasicInfo = this.getPlanInfo ? this.getPlanInfo.planBasicInfo : null
      const roomBasicInfo = this.getPlanInfo ? this.getPlanInfo.roomBasicInfo : null
      if(planBasicInfo && roomBasicInfo) {
        this.dataItemOrder = {
          type: 'type-small',
          menu_id: _.get(planBasicInfo, 'menuNo', ''),
          label: _.get(this.getPlanInfo, 'menuInformation.categoryInfomation', ''),
          baseImg: planBasicInfo.planImages[0].imageUrl,
          title1: _.get(this.getPlanInfo, 'menuInformation.menuNm', ''),
          title2: _.get(planBasicInfo, 'planNm', '')
        }
      }
    },
    numBenepo() {
      if (this.checkedValue === 2) {
        this.amount3 = 0
        return this.amount3
      }
      this.amount3 = this.point_benepo * this.priceOfAPoint
      return this.amount3 
    },
    checkErrorAlert() {
      if (this.point_benepo === '') {
        return 'ベネポを入力してください'
      } else if (this.point_benepo >  this.total_point_benepo) {
        return '有効なベネポを入力してください'
      } else if (this.point_benepo < 0) {
        return 'ベネポの形式が不正です。'
      } else {
        return false
      }
    },
    getTotalPoint() {
      this.$store.dispatch(GET_BENEPO_POINT).then((data) => {
        this.total_point_benepo = _.get(data, 'totalPoint', 0)
        this.point_benepo = _.get(data, 'totalPoint', 0)
        this.mountData()
      },
      /* eslint-disable no-unused-vars */
      (error) => {
        this.mountData()
      })
    },
    gotoScreen(code) {
      const query = this.$route.query
      const {menuNo, planId, roomId} = this.$route.query
      switch(code) {
      case 1:
        this.$router.push({path: '/'})
        return
      case 2:
        this.$router.push({path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`})
        return
      case 3:
        this.$router.push({path: '/register-rooms', query})
      }
    },
    saveData() {
      const query = this.$route.query
      const bs_app_02_008 = {
        point_benepo: this.amount3,
        checkedValue: this.checkedValue,
        dataItemOrder: this.dataItemOrder,
        itemContent: this.itemContent,
        totalAmount: this.totalCost,
        pointRemain: this.total_point_benepo - this.amount3
      }
      this.$store.dispatch(SAVE_DATA_BS_APP_02_008, bs_app_02_008).then(() => {
        // show pop up, navi screen ...
      })
      if (this.checkErrorAlert()) {
        return
      }
      this.$router.push({path: 'register-confirmation', query})
    },
    handleBack() {
      const bs_app_02_008 = {
        point_benepo: this.amount3,
        checkedValue: this.checkedValue,
        dataItemOrder: this.dataItemOrder,
        itemContent: this.itemContent,
        totalAmount: this.totalCost
      }
      this.$store.dispatch(SAVE_DATA_BS_APP_02_008, bs_app_02_008).then(() => {
        // show pop up, navi screen ...
      })
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>